import axios from "./api";

const base = "/admin/rbac/feature";
const permissionBase = "/admin/feature-permissions";
const rolesUserBase = "/business/attach-user-role";
const roleBase = "/admin/rbac/roles";

const RBAC = {
  getAll() {
    return axios.get(base);
  },
  getLocationPlan() {
    return axios.get(`/business/location-plan`);
  },
  deleteRoleForUser(user_id, role_id) {
    return axios.delete(
      `/admin/delete-user-role/${user_id}?role_id=${role_id}`
    );
  },
  getByCompanyId(id) {
    return axios.get(`/admin/feature-permissions-company/${id}`);
  },
  getByLocationId(id) {
    return axios.get(`/admin/feature-permissions-location/${id}`);
  },
  add(body) {
    return axios.post(base, body);
  },
  update(id, body) {
    return axios.put(`${base}/${id}`, body);
  },
  addPermissions(body) {
    return axios.post(permissionBase, body);
  },
  addPermissionsRolesUser(body) {
    return axios.post(rolesUserBase, body);
  },
  addRole(body) {
    return axios.post(roleBase, body);
  },
  getRolesList() {
    return axios.get(roleBase);
  },
  getRoleById(id, body) {
    return axios.put(`${roleBase}/${id}`, body);
  },
  updateRoleName(id, name) {
    return axios.put(`/admin/roles/${id}`, { name });
  },
  deleteRole(id) {
    return axios.delete(`/admin/roles/${id}`);
  },
  updateAttachUserRole(body) {
    return axios.put(`/business/update-attach-user-role`, body);
  },
  getAllUsers() {
    return axios.get(`/admin/user-all`);
  },
};

export default RBAC;
